import React, { useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { loadNav } from "../../reducers/nav";
import { connect } from "react-redux";
import brihhalogo from "../../images/brihhalogo.png";
import { HELP_DESK } from "../../components/common/branding";
import { useFontSize } from "../../context/FontSizeContext";
import {
  Box,
  Drawer,
  Hidden,
  List,
  makeStyles,
  Typography,
} from "@material-ui/core";
import {
  AlertCircle as AlertCircleIcon,
  PenTool as SettingsIcon,
  Users as UsersIcon,
  Calendar as CalendarIcon,
  MessageCircle as NotificationsIcon,
  Layers as CourseIcon,
  MessageSquare as CommunicationIcon,
  Hexagon as OrganizationIcon,
  Clock as Dashboard,
} from "react-feather";
import NavItem from "./NavItem";
import { OrganizationThemeState } from "../../context/OrganizationThemeContext";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 256,
    backgroundColor: "#fff",
  },
  desktopDrawer: {
    width: 256,
    top: 0,
    height: "100%",
    backgroundColor: "#fff",
    boxShadow: "3px 0px 20px #00000014",
    border: "none",
  },
  avatar: {
    cursor: "pointer",
    width: 85,
    height: 85,
  },
  item: {
    display: "flex",
    paddingTop: 6,
    paddingLeft: 8,
    paddingBottom: 0,
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  submenu: {
    paddingLeft: "16px",
  },
  item: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
    color: theme.palette.leftBar.text,
    "& a": {
      "& span": {
        display: "flex !important",
        alignItems: "center !important",
        justifyContent: "center !important",
        gap: "8px !important",
      },
    },
  },
  welcomeText: {
    ...theme.typography.h6,
    fontWeight: theme.typography.fontWeightBold,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  userInfo: {
    padding: theme.spacing(0.5, 0.5, 0.5, 4),
    ...theme.typography.h5,
    fontWeight: theme.typography.fontWeightBold
  },
  userRole: {
    paddingLeft: theme.spacing(0.5),
    color: theme.palette.error.main,
    fontWeight: theme.typography.fontWeightBold,
  },
  list: {
    marginTop: theme.spacing(1),
    padding: 0,
  },
  submenu: {
    paddingLeft: theme.spacing(2),
  },
}));

const JsonIconList = {
  Dashboard,
  SettingsIcon,
  CalendarIcon,
  NotificationsIcon,
  UsersIcon,
  CommunicationIcon,
  CourseIcon,
  AlertCircleIcon,
  OrganizationIcon,
};
const CustomDrawer = (props) => {
  const { fontSizeMultiplier } = useFontSize();
  const { onMobileClose, openMobile, loadNav, session } = props;
  const { themeLogin } = OrganizationThemeState();
  const classes = useStyles();
  const { t } = useTranslation();

  const location = useLocation();
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);
  let UserType = session && session.membership && session.membership.role.name;
  let srcLogo = themeLogin?.logo;

  let userfirst_name = session && session.first_name;
  let userfirst_email = session && session.email;

  let user_name_d = userfirst_name || userfirst_email;
  let view_role = session?.membership?.view_role?.name;
  const isLearner = session?.membership?.view_role?.id === 4

  const nav =
    session &&
    session.profile &&
    session.profile.permissions &&
    JSON.parse(session.profile.permissions);


  const showTab = !["initial", "pending", "Required"].includes(localStorage.getItem("onBoardingStatus"))
  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <div className="logo__wrapper">
        <RouterLink to="/">
          <img
            className="logo__wrapper__img"
            alt="Blended Learning Platform"
            src={srcLogo || brihhalogo}
          />
        </RouterLink>
      </div>
      <Box p={0}>
        {user_name_d && UserType && (
          <Typography
            variant="h4"
            className={classes.welcomeText}
            style={{ fontSize: `${1.1 * fontSizeMultiplier}rem` }}
          >
            {t("sidebar.welcome")}
          </Typography>
        )}
        {user_name_d && UserType && (
          <Typography
            variant="h5"
            className={classes.userInfo}
            style={{ fontSize: `${1 * fontSizeMultiplier}rem` }}
          >
            {user_name_d}
            <span
              className={classes.userRole}
              style={{ fontSize: `${0.8 * fontSizeMultiplier}rem` }}
            >{`${view_role}`}</span>
          </Typography>
        )}

        <List style={{ marginTop: "8px", padding: "0" }}>
          {/* <NavItem
                href={"/settings/work-flows"}
                title={"Setting"}
                icon={"skills"}
                iconName={"twes"}  
            />  */}
          {showTab && nav &&
            nav.length > 0 &&
            nav.map((item, index) => {
              //console.log(item.title);
              return (
                <React.Fragment key={index}>
                  {item.permission && (
                    <NavItem
                      href={item.href}
                      key={item.title}
                      title={t(`sidebar.${item.title}`)}
                      icon={item.icon}
                    />
                  )}
                  <List className={classes.submenu} disablePadding>
                    {item.childrens &&
                      item.childrens.map((children, idx) => {
                        //console.log("Child Title Key from API:", children.title);
                        return (
                          <React.Fragment key={idx}>
                            {children.permission && (
                              <NavItem
                                href={children.href}
                                key={children.title}
                                title={t(`${children.title}`)}
                                icon={children.icon}
                                iconName={children.icon}
                              />
                            )}
                          </React.Fragment>
                        );
                      })}
                  </List>
                </React.Fragment>
              );
            })}

          {showTab && <NavItem
            href={"/digital-library"}
            title={"Digital Library"}
            icon={"digital-library-icon"}
            iconName={"digital-library-icon"}
            className={clsx(classes.item)}
          />}
          {showTab && <NavItem
            href={"#"}
            title={t("sidebar.Content Authoring Tool")}
            icon={"video-conferencing"}
            iconName={"twes"}
            className={clsx(classes.item)}
          />}

          {showTab && <NavItem
            href={"#"}
            title={t("sidebar.Coding Platform")}
            icon={"competencyicon"}
            iconName={"twes"}
            className={clsx(classes.item)}
          />}
          {isLearner && !showTab && <NavItem
            href={"/workforce-onboarding"}
            title={"Workforce Onboarding"}
            icon={"onboarding"}
            iconName={"twes"}
            className={clsx(classes.item)}
          />}
        </List>
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};
const mapStateToProps = (state) => ({
  // nav: state.nav,
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  loadNav: () => dispatch(loadNav()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomDrawer);
